import React from 'react';
import {
  AudioIcon,
  DocumentIcon,
  FavoriteIcon,
  FileIcon,
  ImageIcon,
  ItemIcon,
  JournalPostIcon,
  SurveyAttemptIcon,
  LinkIcon,
  PostIcon,
  UploadIcon,
  VideoIcon
} from './Icons'

export function getTypeIcon(type, variant, props){
  switch (type) {
    case 'Upload':
      switch (variant) {
        case 'audio': return <AudioIcon {...props} alt={type} />;
        case 'image': return <ImageIcon {...props} alt={type} />;
        case 'video': return <VideoIcon {...props} alt={type} />;
        case 'document': return <DocumentIcon {...props} alt={type} />;
        case 'post': return <PostIcon {...props} alt={type} />;
        case 'file': return <FileIcon {...props} alt={type} />;
        default: return <UploadIcon {...props} alt={type} />;
      }
    case 'Link': return <LinkIcon {...props} alt={type} />;
    case 'Favorite': return <FavoriteIcon {...props} alt={type} />;
    case 'JournalPost': return <JournalPostIcon {...props} alt={type} />;
    case 'SurveyAttempt': return <SurveyAttemptIcon {...props} alt={type} />;
    default: return <ItemIcon {...props} alt={type} />
  }
}
export default function ItemTypeIcon(props) {
  //if use props.itemType and props.dataType over props.item
  const { item=null, itemType = null, dataType = null, ...iconProps } = props;
  if(!item){
    return getTypeIcon(itemType, dataType, iconProps);
  }
  return getTypeIcon(itemType || item.item_data_type, dataType || (!!item.item_data ? item.item_data.type : null), iconProps);
}
